import { PageRoutes } from './constants';
import { getType } from './utils.v2';

const layoutTypes = {
  app: 'APP',
  clock: 'CLOCK',
  tile: 'TILE'
};

export const navigateOut = () => {
  window.__webview_comms__.navigate('out');
};

export const arePropDifferentHelper = (nextProps, currentProps, prop) =>
  currentProps[prop] !== nextProps[prop];

export const isValidContentString = (str, { minLength = 1 } = {}) =>
  typeof str === 'string' && str.trim().length >= minLength;

export const payloadFromApp = (app) =>
  !app
    ? undefined
    : {
        appId: app.id,
        appType: app.isClock ? 'clock' : 'app', // app for application and clock for clock face
        buildId: app.buildId, // if available, would be installed version if installed
        developerProfileId: app.developer.id,
        installed: app.isOnDevice, // if app is installed
        versionString: app.versionString // if available
      };

export const isAppPayload = ({ appType = '' } = {}) => appType.includes('app');

export const getPayloadType = ({ appType = '' } = {}) => {
  if (appType.includes('app')) {
    return layoutTypes['app'];
  }

  if (appType.includes('clock')) {
    return layoutTypes['clock'];
  }

  if (appType.includes('tile')) {
    return layoutTypes['tile'];
  }
};

export const getV2Route = (location) => {
  const { type } = location;
  const { isClock } = getType(location);
  switch (type) {
    case PageRoutes.MY_APPS:
    case PageRoutes.GALLERY:
      if (isClock) {
        return PageRoutes.GALLERY_V2_CLOCKS;
      } else {
        return PageRoutes.GALLERY_V2_APPS;
      }
    case PageRoutes.SEARCH:
      return PageRoutes.SEARCH_V2;
    case PageRoutes.COLLECTION:
      return PageRoutes.COLLECTION_V2;
    case PageRoutes.APP:
      return PageRoutes.APP_V2;
    case PageRoutes.PERMISSION:
      return PageRoutes.PERMISSION_V2;
    default:
      return type;
  }
};
